import { render, staticRenderFns } from "./OkrWeeklyTracking.vue?vue&type=template&id=3c473081&scoped=true"
import script from "./OkrWeeklyTracking.vue?vue&type=script&lang=js"
export * from "./OkrWeeklyTracking.vue?vue&type=script&lang=js"
import style0 from "./OkrWeeklyTracking.vue?vue&type=style&index=0&id=3c473081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c473081",
  null
  
)

export default component.exports